module.exports = __webpack_public_path__ + "img/folder-dark-green.84fc2145.svg";